import { PopupAgreementComponent } from './popup-agreement.component';

export const PopupAgreementModule = angular
  .module('sfMobile.components.popup-agreement', [])
  .component('sfPopupAgreement', PopupAgreementComponent).name;
